import React, { useContext, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import EnterPassword from './sections/EnterPassword/EnterPassword';
import LoginCard from './sections/LoginCard/LoginCard';
import Footer from '../../../shared/components/v3/Footer/Footer';
import Toast from '../../../shared/components/v3/Toast/Toast';
import { SIGN_UP_ROUTE } from '../../../shared/constants/auth';
import { LOGIN_ERROR_TOAST } from '../../../shared/constants/toast';
import { SessionContext } from '../../../shared/context/auth/authContext';
import Users from '../../../shared/services/api/users/users';

const Login = () => {
  const [email, setEmail] = useState('');
  const [step, setStep] = useState(0);
  const [errorToast, setErrorToast] = useState(false);

  const { resetError } = useContext(SessionContext);

  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleChangeStep = (newStep: number) => {
    setStep(newStep);
  };

  const changeEmail = async (userEmail: string) => {
    resetError('');
    setEmail(userEmail);
    try {
      const response = await Users.checkEmail(userEmail);
      if (response.verified) {
        setStep(1);
        return;
      }
      navigate(SIGN_UP_ROUTE, { state: { email: userEmail } });
    } catch {
      setErrorToast(true);
    }
  };

  const handleCloseDeleteToast = () => {
    setErrorToast(false);
  };

  return (
    <>
      <div className="auth-container" data-experience="new">
        {step === 0 && <LoginCard changeEmail={changeEmail} />}
        {step === 1 && <EnterPassword email={email} changeStep={handleChangeStep} />}
        <Toast
          title={t(LOGIN_ERROR_TOAST.title)}
          description={t(LOGIN_ERROR_TOAST.description)}
          icon={LOGIN_ERROR_TOAST.icon}
          open={errorToast}
          button={LOGIN_ERROR_TOAST.button}
          buttonAction={handleCloseDeleteToast}
          handleClose={handleCloseDeleteToast}
        />
      </div>
      <Footer login={true} />
    </>
  );
};

export default Login;
